<template>
    <div class="main-container-l">
        <div class="results-menu-l" v-if="isMobile">
            <ResultsPageRoutes v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
            <Calendar v-show="showCalendar && startDate" v-on:changedate="changeDate"></Calendar>
        </div>
        <div class="loading-container" v-if="offerLoading"><img src="../../assets/img/loading.svg"></div>

        <div class="offer-container-l">
            <OutrightsMenuResults
            v-if="!isMobile"
            v-bind:outrightsselected="outrightsselected"
            v-bind:outrights="outrights"
            v-on:selectSpecial="selectSpecial"
            v-on:selectBetGroup="selectBetGroup"
            v-bind:betgroupselected="betgroupselected" />
            <div class="group-offer-l">
                <ResultsPageRoutes
                v-if="!isMobile"
                v-on:toggleCalendar="toggleCalendar"
                v-bind:showCalendar="showCalendar" />

                <div class="offer-menu-box" v-if="isMobile">
                    <div class="games-menu active">
                        <div class="gamesm-item" v-for="special in outrights" :key="special.offerId" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == special.offerId)}">
                            <div class="gamesm-item-content" v-on:click="selectSpecial(special)">
                                <div class="gamesm-content-left">
                                    <div class="gamesm-text">{{special.name | offerlang}} ({{special.betGroups.length}})</div>
                                </div>
                                <div class="gamesm-content-right">
                                    <span class="gamesm-arrow" :class="{'is-selected': (outrightsselected && outrightsselected.offerId == special.offerId)}"></span>
                                </div>
                            </div>
                            <div v-if="outrightsselected">
                                <template v-for="(groupsResult, g) in outrightsselected.groupsResults">
                                    <div class="gamesm-category-box" v-if="outrightsselected.offerId == special.offerId" :key="g" :class="(betgroupselected && betgroupselected.betGroupId == groupsResult.betGroupId) ? 'is-selected' : ''">
                                        <div class="gamesm-category-content" v-on:click.stop="selectBetGroup(groupsResult)">
                                            <div class="gamesm-text small">{{groupsResult.name | offerlang}} ({{groupsResult.oddTypes.length}})</div>
                                        </div>
                                        <OutrightsSingleResults
                                        v-if="outrightsselected
                                        && betgroupselected
                                        && groupsResult
                                        && betgroupselected.betGroupId == groupsResult.betGroupId"
                                        v-bind:outrightsselected="outrightsselected"
                                        v-bind:betgroupselected="betgroupselected" />
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <OutrightsSingleResults
                v-if="!isMobile && outrightsselected && betgroupselected"
                v-bind:outrightsselected="outrightsselected"
                v-bind:betgroupselected="betgroupselected" />
                <div class="group-game empty" v-else-if="outrights.length == 0 && !offerLoading">{{$t('NOOUTRIGHTSFOUNDFORSELECTEDFILTERS')}}</div>
            </div>
        </div>

        <div class="results-menu-l" v-if="!isMobile">
            <div class="results-menu-subcontainer">
                <Calendar v-if="startDate" v-on:changedate="changeDate"></Calendar>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';
import moment from 'moment-timezone';
import OutrightsMenuResults from './containers/OutrightsMenuResults.vue';
import Calendar from '../components/Calendar.vue';
import ResultsPageRoutes from './containers/ResultsPageRoutes.vue';
import OutrightsSingleResults from './containers/OutrightsSingleResults.vue';

export default {
    name: 'OutrightsResults',
    components:
    {
        OutrightsMenuResults,
        OutrightsSingleResults,
        Calendar,
        ResultsPageRoutes,
    },
    data()
    {
        return {
            expandedMenu: true,

            socketParams: false,
            offerStartDate: false,
            offerEndDate: false,
            loading: false,
            gamesMenuShown: false,

            outrights: [],
            outrightsselected: null,
            betgroupselected: null,
            fetchOnLoad: false,
            showCalendar: false,
        };
    },
    created()
    {
        const me = this;

        const startDate = moment().set({ hours: 0, minutes: 0, seconds: 0 });
        const endDate = moment().add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 });

        me.selectDate({ start: startDate, end: endDate });
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'smallDesktop',
            'startDate',
            'endDate',
            'offerLoading',
            'offerHandling',
        ]),
    },
    watch:
    {
        startDate(val)
        {
            const me = this;
            if (val === false)
            {
                return;
            }

            me.betgroupselected = null;
            me.outrightsselected = null;

            me.getOfferByDate();
        },
        betgroupselected(val)
        {
            if (val == null)
            {
                return;
            }

            try
            {
                val.fieldsDefinition = (val.fieldsDefinition instanceof Array)
                    ? val.fieldsDefinition
                    : JSON.parse(val.fieldsDefinition);
            }
            catch (e)
            {
                val.fieldsDefinition = [];
            }
        },
        outrights(val)
        {
            const me = this;

            if (val !== undefined && val != null && val[0] !== undefined && me.outrightsselected == null)
            {
                me.selectSpecial(val[0]);
            }
        },
        outrightsselected(val)
        {
            const me = this;

            if (val !== undefined && val != null && me.betgroupselected == null)
            {
                [me.betgroupselected] = val.groupsResults;
            }
        },
    },
    methods: {
        ...mapActions({
            selectDate: 'selectDate',
            setOfferLoadingInit: 'setOfferLoading',
        }),
        setOfferLoading(status)
        {
            const me = this;
            me.setOfferLoadingInit({ status });
        },
        toggleCalendar()
        {
            const me = this;
            me.showCalendar = !me.showCalendar;
        },
        changeDate(val)
        {
            const me = this;
            me.startDate = val;
        },
        toggleGamesMenu()
        {
            const me = this;
            me.gamesMenuShown = false;
        },
        async selectSpecial(specialIn)
        {
            const me = this;

            if (me.outrightsselected != null && me.outrightsselected.offerId === specialIn.offerId)
            {
                me.outrightsselected = null;
                return;
            }

            me.loading = true;

            const params = {
                specialIds: specialIn.offerId,
            };

            const data = await me.offerHandling.callOffer('/outrights/getOutrightsById', params);

            if (data.data !== undefined && data.data[0] !== undefined)
            {
                const special = data.data[0];

                special.groupsResults = [];

                for (const betGroup of special.betGroups)
                {
                    let fields = [];

                    try
                    {
                        fields = (betGroup.fieldsDefinition instanceof Array)
                            ? betGroup.fieldsDefinition
                            : JSON.parse(betGroup.fieldsDefinition);
                    }
                    catch (e)
                    {
                        fields = [];
                    }

                    const oddTypes = [];

                    for (const oddType of betGroup.oddTypes)
                    {
                        const odds = [];

                        for (const oddTypeOdd of oddType.odds)
                        {
                            if (oddTypeOdd.status === 'active')
                            {
                                continue;
                            }

                            if (oddTypeOdd.status === 'win' && oddTypeOdd.voidFactor === -1)
                            {
                                oddTypeOdd.status = 'refund';
                            }

                            odds.push({
                                name: fields[odds.length],
                                status: oddTypeOdd.status,
                                value: oddTypeOdd.value,
                            });
                        }
                        oddTypes.push({
                            odds,
                            name: oddType.oddTypeName,
                        });
                    }
                    special.groupsResults.push({
                        name: betGroup.betGroupName,
                        oddTypes,
                        betGroupId: betGroup.betGroupId,
                    });
                }

                me.outrightsselected = special;
            }

            me.loading = false;
        },
        selectBetGroup(betGroup)
        {
            const me = this;

            if (me.betgroupselected != null && me.betgroupselected.betGroupId === betGroup.betGroupId)
            {
                me.betgroupselected = null;
                return;
            }

            me.betgroupselected = betGroup;
        },
        async getOfferByDate()
        {
            const me = this;

            if (me.startDate === false || me.offerLoading === true)
            {
                return;
            }
            // if(me.fetchOnLoad == true) return;

            me.showCalendar = false;
            me.setOfferLoading(true);

            me.matchesIn = {};
            me.outrights = [];
            me.outrightsselected = null;

            const params = {
                status: 'finished',
            };

            params.startDate = moment.utc(me.startDate).format('YYYY-MM-DD HH:mm:ss');
            params.endDate = moment.utc(me.endDate).format('YYYY-MM-DD HH:mm:ss');

            const data = await me.offerHandling.callOffer('/offer/getOutrightsOfferByDate', params);

            const outrights = data.data;

            for (const special of outrights)
            {
                me.outrights.push(special);
            }

            me.setOfferLoading(false);
        },
    },
};
</script>

<style>

</style>
